import { __rest } from "tslib";
import * as React from "react";
import { useAutoResize } from "../../components/hooks/use-auto-resize";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
 * import { Textarea } from "@skve/components"
 *
 * function Demo() {
 *   return <Textarea placeholder="Type your message here." />
 * }
 * ```
 */
const Textarea = React.forwardRef((_a, ref) => {
    var { className, autoResize = false } = _a, props = __rest(_a, ["className", "autoResize"]);
    const { textAreaRef } = useAutoResize(ref, autoResize, props.value);
    return (React.createElement("textarea", Object.assign({ className: cn("flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-none", className), ref: textAreaRef }, props)));
});
Textarea.displayName = "Textarea";
export { Textarea };
//# sourceMappingURL=textarea.js.map